import { render, staticRenderFns } from "./subprogram-list-toolbar.vue?vue&type=template&id=10827b8d&"
import script from "./subprogram-list-toolbar.vue?vue&type=script&lang=js&"
export * from "./subprogram-list-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports